// services/manualPaymentService.js
// Service for handling manual payment API calls

const API_URL = process.env.REACT_APP_API_URL;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;
// const BASE_URL = process.env.REACT_APP_BASE_URL;

const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${API_TOKEN}`,
};

export const ManualPaymentService = {
  // Submit manual investment payment
  submitInvestmentPayment: async (paymentData) => {
    console.log({ paymentData });
    try {
      const response = await fetch(`${API_URL}/manual-payments/investment`, {
        method: 'POST',
        headers,
        body: JSON.stringify(paymentData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to submit manual payment');
      }

      return {
        data,
        error: null,
      };
    } catch (error) {
      console.error('Error submitting manual payment:', error);
      return { data: null, error: error.message };
    }
  },

  // Submit manual deposit payment for borrowers
  submitBorrowerDeposit: async (paymentData) => {
    try {
      const response = await fetch(`${API_URL}/manual-payments/deposit`, {
        method: 'POST',
        headers,
        body: JSON.stringify(paymentData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to submit manual deposit');
      }

      return {
        data,
        error: null,
      };
    } catch (error) {
      console.error('Error submitting manual deposit:', error);
      return { data: null, error: error.message };
    }
  },

  // Verify a payment status by reference code
  verifyPaymentStatus: async (referenceCode) => {
    try {
      const response = await fetch(`${API_URL}/manual-payments/verify?referenceCode=${referenceCode}`, {
        method: 'GET',
        headers,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to verify payment status');
      }

      return {
        data,
        error: null,
      };
    } catch (error) {
      console.error('Error verifying payment status:', error);
      return { data: null, error: error.message };
    }
  },

  // Get payment history for a user (investor or borrower)
  getPaymentHistory: async (userId, userType = 'investor') => {
    try {
      const response = await fetch(`${API_URL}/manual-payments/history?userId=${userId}&userType=${userType}`, {
        method: 'GET',
        headers,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to fetch payment history');
      }

      return {
        data,
        error: null,
      };
    } catch (error) {
      console.error('Error fetching payment history:', error);
      return { data: null, error: error.message };
    }
  },
};
